import { render, staticRenderFns } from "./MyAttendance.vue?vue&type=template&id=665a32b6"
import script from "./MyAttendance.vue?vue&type=script&lang=js"
export * from "./MyAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports